export class GcpVmResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<InventoryGcpDisk>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVmResource.attributeTypeMap;
    }
    constructor() {
    }
}
